export default function waitFor(evaluator) {
    var interval = null;

    return new Promise(res => {
        if (evaluator()) {
            res();
        } else {
            interval = setInterval(function () {
                if (evaluator()) {
                    clearInterval(interval);
                    interval = null;
                    res();
                }
            }, 100);
        }
    });
}